import React from 'react';

interface IProps {
  label?: string;
  name?: string;
  id?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  style?: React.CSSProperties;
  defaultValue?: string | number;

  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  maxLength?: number;
  error?: string;
}

const CustomNumber = (props: IProps) => {
  const [inputValue, setInputValue] = React.useState<string>(props.value || '');

  React.useEffect(() => {
    if (props.value !== undefined && props.value !== null) {
      const str = typeof props.value === 'string' ? props.value : String(props.value);
      const validInputValue = str.replace(/[^0-9]/g, '');
      setInputValue(validInputValue);
    } else {
      if (typeof props.defaultValue === 'number') {
        setInputValue(String(props.defaultValue));
      } else {
        setInputValue('');
      }
    }
  }, [props.value]);

  const handleOnchange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const validInputValue = e.target.value.replace(/[^0-9]/g, '');
    setInputValue(validInputValue);
    e.target.value = validInputValue;
    props.onChange?.(e);
  };

  return (
    <div className={`custom-number ${props.className || ''}`} style={props.style}>
      {props.label && <label htmlFor={props.id}>{props.label}</label>}
      <input
        id={props.id}
        name={props.name}
        type="text"
        placeholder={props.placeholder}
        value={inputValue}
        inputMode="numeric"
        pattern="\\d*"
        onChange={handleOnchange}
        disabled={props.disabled}
        readOnly={props.readOnly}
        maxLength={props.maxLength}
      />
      {props.error && <div className="error-text">{props.error}</div>}
    </div>
  );
};

export default CustomNumber;
